import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '..\\layouts\\error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_toast_1262cbaa from 'nuxt_plugin_toast_1262cbaa' // Source: .\\toast.js (mode: 'client')
import nuxt_plugin_axios_2a9e4d7c from 'nuxt_plugin_axios_2a9e4d7c' // Source: .\\axios.js (mode: 'all')
import nuxt_plugin_externalscripts_186cd80a from 'nuxt_plugin_externalscripts_186cd80a' // Source: ..\\plugins\\external-scripts.js (mode: 'client')
import nuxt_plugin_filters_2b4f519a from 'nuxt_plugin_filters_2b4f519a' // Source: ..\\plugins\\filters.js (mode: 'all')
import nuxt_plugin_antdui_2b2dca90 from 'nuxt_plugin_antdui_2b2dca90' // Source: ..\\plugins\\antd-ui (mode: 'all')
import nuxt_plugin_mailer_e2fef942 from 'nuxt_plugin_mailer_e2fef942' // Source: ..\\plugins\\mailer.js (mode: 'all')
import nuxt_plugin_scrollToTop_545857be from 'nuxt_plugin_scrollToTop_545857be' // Source: ..\\plugins\\scrollToTop.js (mode: 'all')
import nuxt_plugin_mixins_6f76c2a4 from 'nuxt_plugin_mixins_6f76c2a4' // Source: ..\\plugins\\mixins.js (mode: 'all')
import nuxt_plugin_vuelidate_4345260a from 'nuxt_plugin_vuelidate_4345260a' // Source: ..\\plugins\\vuelidate (mode: 'all')
import nuxt_plugin_global_c4edad06 from 'nuxt_plugin_global_c4edad06' // Source: ..\\plugins\\global.js (mode: 'all')
import nuxt_plugin_vue2editor_345c4d3f from 'nuxt_plugin_vue2editor_345c4d3f' // Source: ..\\plugins\\vue2-editor.js (mode: 'client')
import nuxt_plugin_vuescript2_d1d16126 from 'nuxt_plugin_vuescript2_d1d16126' // Source: ..\\plugins\\vue-script2.js (mode: 'client')
import nuxt_plugin_clientloggerclient_45afe4fa from 'nuxt_plugin_clientloggerclient_45afe4fa' // Source: ..\\plugins\\client-logger.client.js (mode: 'client')
import nuxt_plugin_globalbridgeclient_22c8cadb from 'nuxt_plugin_globalbridgeclient_22c8cadb' // Source: ..\\plugins\\global-bridge.client.js (mode: 'client')
import nuxt_plugin_plugin_6eb59faa from 'nuxt_plugin_plugin_6eb59faa' // Source: .\\auth\\plugin.js (mode: 'all')
import nuxt_plugin_auth_7f7561ce from 'nuxt_plugin_auth_7f7561ce' // Source: ..\\plugins\\auth.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Jewish Jobs on Macher: The Largest Jewish Jobs Website in the US","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"The largest jewish jobs website in NYC, Brooklyn, Boro Park, Five Towns, Crown Heights, Woodmere, Monsey, Lakewood and more."}],"link":[{"rel":"stylesheet","href":"\u002Fcss\u002Fstyle.css"},{"rel":"stylesheet","href":"\u002Fcss\u002Fcolors\u002Fblue.css"},{"rel":"stylesheet","href":"\u002Fcss\u002Fmodal.css"},{"rel":"stylesheet","href":"\u002Fsass\u002Fglobal.scss"},{"rel":"stylesheet","href":"\u002Fcss\u002Fbootstrap-fs-modal.css"},{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"script":[{"src":"\u002Fjs\u002Fjquery-3.3.1.min.js","defer":true},{"src":"\u002Fjs\u002Fjquery-migrate-3.0.0.min.js","defer":true},{"src":"\u002Fjs\u002Fmmenu.min.js","defer":true},{"src":"\u002Fjs\u002Ftippy.all.min.js","defer":true},{"src":"\u002Fjs\u002Fsimplebar.min.js","defer":true},{"src":"\u002Fjs\u002Fslick.min.js","defer":true},{"src":"\u002Fjs\u002Fcustom.1.js","defer":true},{"src":"\u002Fjs\u002Futil.js","defer":true},{"src":"\u002Fjs\u002Fmodal.js","defer":true}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.client && typeof nuxt_plugin_toast_1262cbaa === 'function') {
    await nuxt_plugin_toast_1262cbaa(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2a9e4d7c === 'function') {
    await nuxt_plugin_axios_2a9e4d7c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_externalscripts_186cd80a === 'function') {
    await nuxt_plugin_externalscripts_186cd80a(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_2b4f519a === 'function') {
    await nuxt_plugin_filters_2b4f519a(app.context, inject)
  }

  if (typeof nuxt_plugin_antdui_2b2dca90 === 'function') {
    await nuxt_plugin_antdui_2b2dca90(app.context, inject)
  }

  if (typeof nuxt_plugin_mailer_e2fef942 === 'function') {
    await nuxt_plugin_mailer_e2fef942(app.context, inject)
  }

  if (typeof nuxt_plugin_scrollToTop_545857be === 'function') {
    await nuxt_plugin_scrollToTop_545857be(app.context, inject)
  }

  if (typeof nuxt_plugin_mixins_6f76c2a4 === 'function') {
    await nuxt_plugin_mixins_6f76c2a4(app.context, inject)
  }

  if (typeof nuxt_plugin_vuelidate_4345260a === 'function') {
    await nuxt_plugin_vuelidate_4345260a(app.context, inject)
  }

  if (typeof nuxt_plugin_global_c4edad06 === 'function') {
    await nuxt_plugin_global_c4edad06(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vue2editor_345c4d3f === 'function') {
    await nuxt_plugin_vue2editor_345c4d3f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescript2_d1d16126 === 'function') {
    await nuxt_plugin_vuescript2_d1d16126(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clientloggerclient_45afe4fa === 'function') {
    await nuxt_plugin_clientloggerclient_45afe4fa(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_globalbridgeclient_22c8cadb === 'function') {
    await nuxt_plugin_globalbridgeclient_22c8cadb(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_6eb59faa === 'function') {
    await nuxt_plugin_plugin_6eb59faa(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_7f7561ce === 'function') {
    await nuxt_plugin_auth_7f7561ce(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
